import { render, staticRenderFns } from "./JLoader.vue?vue&type=template&id=74e0e1c0"
import script from "./JLoader.vue?vue&type=script&lang=js"
export * from "./JLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports